export const EncryptionTypesEnum = {
    None: 'None',
    Tls: 'Tls',
    Ssl: 'Ssl'
};